export default "__VITE_ASSET__CX3E0d5F__"